module.exports = new __parcel__URL__("faq_content_zh-tw.2a7610aa.webp").toString();